import React from 'react';

const AuxFooter = () => {
  return (
    <footer
      style={{
        paddingTop: '1rem',
        backgroundColor: 'white',
      }}
    >
      
      <footer className="footer--slim">
        <div className="footer__container">
          <div className="footer__columns">
            <div className="footer__column footer__column--identity">
              <div className="identity">
                <a href="#">
                  <div className="identity__logo">
                    <img
                      alt="Texas A&M University logo"
                      src="https://aux.tamu.edu/logos/boxTAM.svg"
                    />
                  </div>
                  <div className="identity__wordmark">
                    <span className="wordmark__small">Texas A&amp;M University </span>
                    <span className="wordmark__large">Institute of Data Science</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="footer__column">
              <span className="column__header">   ADDRESS</span>
              <address>
                <p>1246 TAMU</p>
                <p>Texas A&amp;M University</p>
                <p>College Station, TX 77843-1246</p>
              </address>
            </div>
          </div>
        </div>
        <div className="footer__compliance-wrapper">
            <div className="footer__compliance">
              <ul className="compliance__list">
                <li>© 2023 <a href="https://www.tamu.edu/">Texas A&amp;M University</a></li>
                <li><a href="https://www.tamu.edu/statements/">Site Policies</a></li>
                <li><a href="https://itaccessibility.tamu.edu/">Accessibility</a></li>
              </ul>
          </div>
        </div>
      </footer>
    </footer>
  );
};

export default AuxFooter;
